import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createAllInOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getShortRenderedValueStr } from '../../../../utils/numberPrecisionUtils';
import { Button } from '../../pixiComponents/button';
export const PixiAllInButton = ({ bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickAllIn = useCallback(() => {
        socketSend(createAllInOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    const subLabelAmount = myTurnProperties.myNumChipsThisPhase + myTurnProperties.myNumChips;
    const subLabelProperties = subLabelAmount > 0
        ? {
            label: getShortRenderedValueStr(subLabelAmount),
            bitmapTextStyleType: 'button-sub-label',
            labelPixiDataType: 'button-sub-label'
        }
        : undefined;
    return (_jsx(Button, { pixiObjectData: { type: 'all-in-button' }, onClick: onClickAllIn, labelProperties: {
            label: 'ALL-IN',
            bitmapTextStyleType: 'button-label',
            labelPixiDataType: 'button-label'
        }, subLabelProperties: subLabelProperties, bounds: bounds, accentColor: 'green' }));
};
